import React, { useEffect } from 'react';
import { Landing } from './pages/pangea';

const App = () => {
  useEffect(() => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      // TODO: dev code
    } else {
      //document.querySelector('html').style.overflow = 'hidden';
    }
  }, [])

  return <Landing />
}

export default App;
